/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "connect": {
        "nested": {
          "v2": {
            "nested": {
              "SoftwareUpdateDetails": {
                "fields": {
                  "state": {
                    "type": "squareup.connect.v2.SoftwareUpdateDetails.State",
                    "id": 1,
                    "rule": "optional"
                  },
                  "lastUpdateCheckAt": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "isDeferrable": {
                    "type": "bool",
                    "id": 3,
                    "rule": "optional"
                  },
                  "scheduledUpdateAt": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "failureReason": {
                    "type": "squareup.connect.v2.SoftwareUpdateDetails.FailureReason",
                    "id": 5,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "State": {
                    "values": {
                      "UPDATE_STATE_INVALID_TYPE": 0,
                      "UP_TO_DATE": 1,
                      "UPDATE_AVAILABLE": 2,
                      "DOWNLOAD_IN_PROGRESS": 3,
                      "READY_TO_INSTALL": 4,
                      "INSTALLATION_IN_PROGRESS": 5,
                      "UPDATE_FAILED": 6
                    }
                  },
                  "FailureReason": {
                    "values": {
                      "FAILURE_REASON_INVALID_TYPE": 0,
                      "DOWNLOAD_FAILED": 1,
                      "INSTALL_FAILED": 2,
                      "INSTALL_INTERRUPTED": 3,
                      "INSTALL_FAILED_BATTERY": 4,
                      "INSTALL_FAILED_FATAL": 5,
                      "DOWNLOAD_FAILED_OUT_OF_SPACE": 6,
                      "UNEXPECTED_EXCEPTION": 7,
                      "FWUP_FAILED": 8,
                      "FWUP_FATAL": 9,
                      "UNKNOWN_SOFTWARE_UPDATE_FAILURE_REASON": 10,
                      "CHECK_FOR_UPDATES_NETWORK_FAILURE": 11,
                      "CHECK_FOR_UPDATES_FAILURE": 12,
                      "DOWNLOAD_FAILED_NETWORK_FAILURE": 13,
                      "DOWNLOAD_FAILED_SERVICE_UNAVAILABLE": 14
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.SoftwareUpdateDetails && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.SoftwareUpdateDetails?.nested?.State && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.SoftwareUpdateDetails?.nested?.FailureReason) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE SoftwareUpdateDetails @ squareup/devices/external/software_update_details.proto at 11:1
 */
export const SoftwareUpdateDetails = $root.lookupType('squareup.connect.v2.SoftwareUpdateDetails');
fixType(SoftwareUpdateDetails);
Builder.createAndAttachToType(SoftwareUpdateDetails);
/**
 * SOURCE State @ squareup/devices/external/software_update_details.proto at 14:3
 */
SoftwareUpdateDetails.State = $root.lookupEnum('squareup.connect.v2.SoftwareUpdateDetails.State').values;
/**
 * SOURCE FailureReason @ squareup/devices/external/software_update_details.proto at 70:3
 */
SoftwareUpdateDetails.FailureReason = $root.lookupEnum('squareup.connect.v2.SoftwareUpdateDetails.FailureReason').values;